import Head from "next/head";
import Image from "next/image";
import { Layout } from "@/components/Layout";
import { PageTitle } from "@/components/PageTitle";
import { SectionContainer } from "@/components/SectionContainer";
import davidCraneHeadshot from "@/images/headshots/DavidCrane.jpg";

export default function WhoWeAre() {
  const pageTitle = "David Crane";

  return (
    <>
      <Head>
        <title>{`${pageTitle} - Govern For California`}</title>
        <meta
          name="description"
          content="About David Crane, President of Govern For California"
        />
        <meta name="keywords" content="David Crane" />
      </Head>
      <Layout mobileTitle={pageTitle}>
        <PageTitle title={pageTitle} />
        <SectionContainer bgColor={"bg-white"} aria-label="Meet GFC staff">
          <div className="mb-12 sm:my-6">
            <Image
              src={davidCraneHeadshot}
              alt="David Crane headshot"
              className="max-w-[10rem] pt-0 sm:mx-auto md:pt-6 lg:mx-0"
            />
            <p className="mt-6 sm:text-center md:mt-12 lg:text-left">
              David Crane is a Lecturer in Public Policy at Stanford University
              and the co-founder and president of Govern For California.
            </p>
            <p className="mt-6 sm:text-center md:mt-12 lg:text-left">
              <a href="https://davidcrane.substack.com" className="body-link">
                On California - David Crane Substack
              </a>
            </p>
          </div>
        </SectionContainer>
      </Layout>
    </>
  );
}
